import { useMatrixCommercial } from '../../hooks/use-matrix-commercial';
import { useMatrixClub } from '../../state-management/server-state/use-matrix-club';
import CardSkeleton from '@ifit/mp-card-skeleton';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { useUserWorkoutDetails } from '../../state-management/server-state/use-user-workout-details';
import CardWorkout from '../cards/workout';
import { intensityConverter } from '../../util/intensity';
import './index.scss';

const skeletonCards = Array(14).fill(0);

export default function MatrixClub(): JSX.Element {
  const isMatrixCommercial = useMatrixCommercial();
  const matrixClubQuery = useMatrixClub(false);
  const { data, error, isLoading, isSuccess } = matrixClubQuery;
  const workoutIds = data?.map((workout) => workout.id);
  const userWorkoutDetailsQuery = useUserWorkoutDetails(workoutIds);
  const { data: userWorkoutDetail } = userWorkoutDetailsQuery;

  if (!isMatrixCommercial) {
    return null;
  }

  const noValidData = !data || data.length === 0;
  const errorWithNoCachedData = error && noValidData;
  const successWithNoData = noValidData && isSuccess;
  const hideRow = errorWithNoCachedData || successWithNoData;

  if (hideRow) {
    return null;
  }

  let content: JSX.Element[];

  if (isLoading) {
    content = skeletonCards.map((_, index) => <CardSkeleton key={index} className="custom" />);
  } else {
    content = data.slice(1).map(({ id, images, title, workout: { averageRating: average, intensity, url } }, index) => {
      const clickHandler = getUserNavigationHandler(url, ROWTITLES.MATRIX_COMMERCIAL_WORKOUTS);
      const estimates = {
        calories: userWorkoutDetail?.[index + 1]?.estimates?.calories,
        distance: userWorkoutDetail?.[index + 1]?.estimates?.distance,
        time: userWorkoutDetail?.[index + 1]?.estimates?.duration,
      };
      const formattedRating = average ? `${Number.parseFloat(`${average}`).toFixed(1)}` : null;

      return (
        <CardWorkout
          key={id}
          onClick={clickHandler}
          className="matrix-club-link"
          estimates={estimates}
          imageUrl={images.thumbnail}
          tagPrimary={intensityConverter(intensity)}
          averageRating={formattedRating}
          title={title}
        />
      );
    });
  }

  return <div className="matrix-club-row">{content}</div>;
}
